import { useParams } from 'react-router-dom'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { buscarVivo } from '../../db/registroVivo'
import TelaPedido from './TelaPedido'
import DetalhePedido from './DetalhePedido'

export default function PedidoRoteador() {
  const { id } = useParams()
  const pedido = useLiveQuery(() => buscarVivo(banco.pedidos, id), [id])
  if (!pedido) return <p className="p-4 text-sm text-slate-500">Carregando…</p>
  return pedido.status === 'aberto' ? <TelaPedido /> : <DetalhePedido />
}
